export type CvSearchSyncStatusTranslation = {
  button: string;
  counters: {
    eligibleCandidates: string;
    inCvSearch: string;
    orangeCandidates: string;
    pendingSync: string;
    readyInCvSearch: string;
    skipped: string;
    taggingInProgress: string;
    title: string;
    waitingForEmbedding: string;
  };
  drawer: {
    close: string;
    computedAt: string;
    eligibilityRule: string;
    eligibilityRuleTitle: string;
    noData: string;
    noPending: string;
    oldestPending: string;
    recompute: string;
    syncDisabled: string;
    syncEnabled: string;
    title: string;
  };
  problems: {
    categories: {
      CV_MISSING: CategoryTranslation;
      EMBEDDING_STUCK: CategoryTranslation;
      MISSING_IN_CV_SEARCH: CategoryTranslation;
      NOT_ELIGIBLE_IN_CV_SEARCH: CategoryTranslation;
      ORPHAN_IN_CV_SEARCH: CategoryTranslation;
      RETRYING: CategoryTranslation;
      SEND_FAILED: CategoryTranslation;
      TAGGING_FAILED: CategoryTranslation;
    };
    shown: string;
    title: string;
  };
  tooltip: {
    disabled: string;
    status: string;
    unknown: string;
  };
};

type CategoryTranslation = {
  description: string;
  title: string;
};

export const cvSearchSyncStatusTranslation: CvSearchSyncStatusTranslation = {
  button: 'CV Search synchronization status',
  counters: {
    eligibleCandidates: 'Eligible for CV Search',
    inCvSearch: 'In CV Search',
    orangeCandidates: 'Candidates in KnowMe',
    pendingSync: 'Waiting for synchronization',
    readyInCvSearch: 'Ready in CV Search',
    skipped: 'Skipped (no valid consent)',
    taggingInProgress: 'Keyword assignment queued or running',
    title: 'Counters',
    waitingForEmbedding: 'Waiting for embedding',
  },
  drawer: {
    close: 'Close',
    computedAt: 'Data as of {{time}}',
    eligibilityRule:
      'Not marked for deletion and has at least one application with consent for future recruitments whose retention date and processing stop date (if set) are at least one year from now. A current CV is also required to send the candidate.',
    eligibilityRuleTitle: 'Who is sent to CV Search',
    noData: 'No data yet. Compute the status to see it.',
    noPending: 'No synchronization is waiting',
    oldestPending: 'Oldest waiting synchronization: {{time}}',
    recompute: 'Recompute now',
    syncDisabled: 'Synchronization is disabled in configuration',
    syncEnabled: 'Synchronization is enabled',
    title: 'CV Search synchronization',
  },
  problems: {
    categories: {
      CV_MISSING: {
        description: 'Eligible candidates that cannot be sent because they have no current CV.',
        title: 'CV missing',
      },
      EMBEDDING_STUCK: {
        description: 'In CV Search without embeddings for more than an hour since the last change.',
        title: 'Embedding stuck',
      },
      MISSING_IN_CV_SEARCH: {
        description: 'Marked as synchronized in KnowMe but not present in CV Search.',
        title: 'Missing in CV Search',
      },
      NOT_ELIGIBLE_IN_CV_SEARCH: {
        description:
          'Present in CV Search although consent expired, was withdrawn or the candidate is marked for deletion.',
        title: 'In CV Search without valid consent',
      },
      ORPHAN_IN_CV_SEARCH: {
        description: 'Present in CV Search but unknown to KnowMe.',
        title: 'Orphans in CV Search',
      },
      RETRYING: {
        description: 'Sending failed and will be retried in the next synchronization.',
        title: 'Retrying',
      },
      SEND_FAILED: {
        description: 'Sending failed 3 times and will not be retried automatically.',
        title: 'Sending failed',
      },
      TAGGING_FAILED: {
        description: 'Keyword assignment failed or was never queued in CV Search.',
        title: 'Keyword assignment failed',
      },
    },
    shown: 'Showing {{shown}} of {{count}}',
    title: 'Problems',
  },
  tooltip: {
    disabled: 'CV Search synchronization is disabled',
    status: 'CV Search synchronization: problems {{count}} · data as of {{time}}',
    unknown: 'CV Search synchronization: no data',
  },
};
